import { confluenceLocalStorageInstance as localStorage } from '@confluence/storage-manager';

import type { ExperimentalQueries } from '../__types__/ExperimentalQueries';

export const DEFAULT_TTL_NOT_SEEN = 60 * 60; // 1 hour
export const DEFAULT_TTL_SEEN = 60 * 60 * 24 * 30; // ~1 month

export const experimentalFetchHaveISeenIt: ExperimentalQueries['experimentalFetchHaveISeenIt'] = (
	_,
	{ flagKey },
	{ network },
) => {
	if (!flagKey) return {};

	const localStorageKey = `cf_hisi_${flagKey}`;
	const flagValue = localStorage.getItem(localStorageKey);
	if (flagValue) {
		return JSON.parse(flagValue);
	}

	return network
		.cfetch(`/gateway/api/flag/my?flagKey=${flagKey}`, {
			method: 'GET',
		})
		.then((response) => response.json())
		.then((responseJson) => {
			localStorage.setItem(
				localStorageKey,
				JSON.stringify(responseJson),
				responseJson.status ? DEFAULT_TTL_SEEN : DEFAULT_TTL_NOT_SEEN,
			);
			return responseJson;
		});
};
